
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.995 22h9V2h-9v2h7v16h-7v2z"}}),_c('path',{attrs:{"d":"M7.829 13l3.242 3.242-1.414 1.415L4 12l5.657-5.657 1.414 1.414L7.83 11H16v2H7.829z"}})])
          )
        }
      }
    